import { FormAddress } from '@/models/common/address';
import { LocationModel } from '@/models/common/location';
import { TimeHelper } from '@/helpers/TimeHelper';

class GroupModel {
  id;
  farmId;
  createdOn;
  name;
  description;
  email;
  phone;
  timezone;
  address;
  location;
  status;
  produce;
  surveillance;

  constructor(data) {
    this.populate(data || {});
  }

  get dateCreated() {
    return TimeHelper.formatDate(this.createdOn);
  }

  populate(data) {
    this.id = data.id || null;
    this.farmId = data.farmId || null;
    this.createdOn = data.createdOn || null;
    this.name = data.name || '';
    this.description = data.description || '';
    this.status = data.status || '';
    this.email = data.email || '';
    this.phone = data.phone || '';
    this.timezone = data.timezone || '';
    this.produce = data.produce || '';
    this.address = new FormAddress(data.address || null);
    this.location = new LocationModel(data.location || null);
    this.surveillance = data.surveillance || null;
  }

  toDetailsUpdateJson(originalData) {
    let output = {};
    if (this.name !== originalData.name) output.name = this.name;
    if (this.phone !== originalData.phone) output.phone = this.phone;
    if (this.email !== originalData.email) output.email = this.email;
    if (this.timezone !== originalData.timezone) output.timezone = this.timezone;
    if (this.produce !== originalData.produce) output.produce = this.produce;
    if (this.description !== originalData.description) output.description = this.description;
    if (this.status !== originalData.status) output.status = this.status;
    if (this.surveillance !== originalData.surveillance) output.surveillance = this.surveillance;
    if (this.location.hasChanged(originalData.location)) {
      output.location = this.location;
    }
    output.address = this.address;
    return output; // TODO first check if object is empty
  }

  exportToCreate() {
    let payload = {
      farmId: this.farmId,
      name: this.name,
      email: this.email,
      timezone: this.timezone
    };
    if (this.address.isPopulated) payload.address = this.address;
    if (this.location.isValid) payload.location = this.location;
    return payload;
  }
}

export { GroupModel };
